const CURRENCY_CODE = 'GBP';

const MOBILE_TARIFF_NAMES_FORMATTED = {
  ESSENTIAL: 'Essential',
  UNLIMITED_PLUS: 'Unlimited+',
  UNLIMITED_MAX: 'Unlimited Max',
  ESSENTIAL_MAX: 'Essential Max',
  GO_ESSENTIAL: 'Go Essential',
  GO_UNLIMITED: 'Go Unlimited',
} as const;
export { CURRENCY_CODE, MOBILE_TARIFF_NAMES_FORMATTED };
